module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account-owner-settings/account-owner-settings.component.scss
// module id = ./src/app/account-owner-settings/account-owner-settings.component.scss
// module chunks = main